module.exports = __webpack_public_path__ + "img/activityMobM.8ee0573b.png";